import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css";
import { Alert, Autocomplete, Avatar, Box, Button, Drawer, FormControl, FormControlLabel, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Pagination, Rating, Select, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import profile from '../../assets/common/images/profile.png'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { ArrowBackIos, ArrowDownward, ArrowDropDown, ArrowDropUp, ArrowForward, ArrowForwardIos, ArrowOutward, BarChart, Business, CalendarViewMonth, CancelOutlined, Category, CheckCircle, DonutLarge, EmojiEvents, LocationPin, NorthOutlined, QuestionMark, Schedule, SouthOutlined, Star, StarBorderOutlined, StarOutline, Translate, TrendingUp, Warning, WorkspacePremium } from '@mui/icons-material';
import GroupReport from '../../Components/Charts/GroupReport';
import Footer from '../../Components/Footer/Footer';
import { ApiAldiGroupScore, ApiAldiRegionRanking, ApiComplimentReport, ApiDashboard, ApiGetCategoryHeatMap, ApiGetCategoryScores, ApiGetDashboardLowestScoringQuestions, ApiGetDashboardScoreByCategory, ApiGetDashboardScoreTrend, ApiGetDashboardStarRatingSummary, ApiGetGroupReport, ApiGetQuestionListForBusness, ApiGetRecentReports, ApiGetScoreDistribution, ApiGetStarRatingAverage, ApiGetVenueAdminData, ApiGetVenueLeaderBoard, ApiGetVenueLeaderBoardDetails, ApiGetVenueList, ApiRegionVenues, ApiVenuePerformance } from '../../apiService/Core/Apicall';
import { log } from 'console';
import chartlabel from '../../assets/images/styleimages/chartlabel.png'
import { useDispatch, useSelector } from 'react-redux';
import { Images } from '../../global/GloblImages';
import Domains from '../../global/constants/domain';
import { boolean, number } from 'yup';
import { RootState } from '../../global/config/store';
import { data, Link, useNavigate } from 'react-router-dom';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import { setisWholeGroup } from '../../global/config/Reducer/WholeGroupSlice';
import storage from '../../utils/storage';
import DoubleLineChart from '../../Components/Charts/DoubleLineChart';
import TrendChart from '../../Components/Charts/TrendChart';
import DonutChart from '../../Components/Charts/DountChart';
import npsicon from '../../assets/common/images/nps_icon.png'


const getIconColorByDomain = () => {
  const domain = window.location.hostname;

  if (domain.includes(Domains.ALDI)) return ['#1C2B9033', '#F96E091A', '#FFBF44', '#00B5DC'];       // Example: ALDI color
  if (domain.includes(Domains.BLOOMS)) return ['#1C2B9033'];     // Example: BLOOMS color
  if (domain.includes(Domains.MM)) return ['#E3DDD1'];         // Example: MM color

  return ['#E3DDD1'];
};
function Dashboard() {
  const chart_bgcolor = getIconColorByDomain()
  const domain = window.location.hostname
  const userData = JSON.parse(storage.getItem("userData") || "{}");
  const isAldi = domain.includes('aldi');
  const navigate = useNavigate()
  const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
  const dispatch = useDispatch()
  const [reportyear, setreportyear] = useState<any>(dayjs(selectedMonth))
  const [groupreport, setgroupreport] = useState<any>([])
  const [dashboard, setdashboard] = useState<any>([])
  const [venueperformance, setvenueperformance] = useState<any>([])
  const [venueAdminData, setvenueAdminData] = useState<any>([])
  const [RegionRanking, setRegionRanking] = useState<any>([])
  const [compliment, setcompliment] = useState<any>()
  const [month, setmonth] = useState<any>(dayjs(selectedMonth))
  const [scores, setScores] = useState<number[]>(new Array(12).fill(0));
  const [scores2, setScores2] = useState<number[]>(new Array(12).fill(0));
  const { m1, m2, m3, m4 } = Images()
  const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
  const { isWholeGroup, clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
  const [venuelist, setvenuelist] = useState<any[]>([])
  const [venues, setvenues] = useState<number | string>('')
  const Regions = useSelector(RegionList)
  const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
  const isratingJson = storage.getItem('ratingJson')
  const [categoryVenue, setCategoryVenues] = useState<number>(0)
  const [data2, setData2] = useState<any>([])
  const [clientData, setClientData] = useState<any>([])
  const lastPayloadRef = useRef<Record<string, string>>({});
  const [isShowNPS, setIsShowNPS] = useState<boolean>(storage.getItem("cssNPS") === "1")
  const [showLoading, setShowLoading] = useState<boolean>(false)
  const [openVenueDetails, setopenVenueDetails] = useState<boolean>(false)
  const [isSDYTD, setISSDYTD] = useState<string>("false")
  const [isSLYTD, setIsSLYTD] = useState<string>("false")
  const [isSRYTD, setIsSRYTD] = useState<string>("false")
  const [isYTD, setIsYTD] = useState<string>("false")

  useEffect(() => {
    clientEntity && setIsShowNPS(storage.getItem("cssNPS") === "1")
    // if(storage.getItem("cssNPS") !== "1" && selectedbutton === "netpromoterscore"){
    //     setselectedbutton('categoryreport')
    // }
  }, [clientEntity])

  const shouldSkip = (key: string, payload: string) => {
    if (lastPayloadRef.current[key] === payload) return true;
    lastPayloadRef.current[key] = payload;
    return false;
  };

  // const [page, setPage] = useState(1);

  // const rowsPerPage = 5; // Number of items per page

  // const totalPages = Math.ceil((data2?.sbc?.length || 0) / rowsPerPage);

  // const paginatedData =
  //   data2?.sbc?.slice(
  //     (page - 1) * rowsPerPage,
  //     page * rowsPerPage
  //   ) || [];
  const [pages, setPages] = useState<any>({}); // { cardKey: pageNumber }
  const rowsPerPage = 5;
  const getPage = (key: any) => pages[key] || 1;

  const setPage = (key: string, pageNum: number) => {
    setPages((prev: any) => ({ ...prev, [key]: pageNum }));
  };
  const getTotalPages = (key: string, dataArr: any) => Math.ceil((dataArr?.length || 0) / rowsPerPage);

  const getPaginatedData = (key: string, dataArr: any) => {
    const currentPage = getPage(key);
    return (
      dataArr?.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
      ) || []
    );
  };

  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  useEffect(() => {
    if (storage.getItem('userRole') === 'venueadmin') {
      setvenues(venuelist?.[0]?.venueId)
    }
  }, [venuelist])



  useEffect(() => {
    const getyearreport = async () => {
      const data = `?year=${reportyear.year()}&clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      const data2 = `?year=${reportyear.year()}&clientEntityId=${storage.getItem('clientEntityId')}${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

      if (shouldSkip('aldi-group-report', data2)) return;
      // if (shouldSkip('group-report', data)) return;
      try {
        const response = (isAldi && storage.getItem('clientEntityName') !== 'Liquor ID') ? await ApiAldiGroupScore(data2) : await ApiGetGroupReport(data)
        isAldi && await AldiRegionRanking()

        setgroupreport(response.data)


        if ((response?.data || []) && isAldi && (storage.getItem('clientEntityName') !== 'Liquor ID')) {
          setScores([])
          setScores2([])
          const updatedScores = new Array(12).fill(0);
          const updatedScores2 = new Array(12).fill(0);
          response?.data?.complianceScore.map((item: any) => {
            const monthIndex = item.month - 1;
            updatedScores[monthIndex] = parseFloat(parseFloat(item.complianceScore).toFixed(2));
          });
          setScores(updatedScores);

          response?.data?.mystryShopeScore.map((item: any) => {
            const monthIndex = item.month - 1;
            updatedScores2[monthIndex] = parseFloat(parseFloat(item.mystryShopeScore).toFixed(2));
          });
          setScores2(updatedScores2);
        }
        else if (response.data) {
          const updatedScores = new Array(12).fill(0);
          response?.data?.length > 0 && response?.data?.map((item: any) => {
            const monthIndex = item.reportMonth - 1;
            updatedScores[monthIndex] = parseFloat(parseFloat(item.avgScore).toFixed(2));
          });
          setScores(updatedScores);
        }
        // setgroupreport([response.data])
      }
      catch (error: any) {
        // toast.error(error)
        console.log("Error", error)
      }

    }
    reportyear && clientEntity && getyearreport()

  }, [reportyear, venues, clientEntity, isWholeGroup])

  const venueAdmin = async () => {
    try {
      const data = `?clientEntityId=${storage.getItem('clientEntityId')}&isClientEntityIdRequired=true${venues ? `&venueId=${venues}` : ''}&month=${month.month() + 1}&year=${month.year()}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      const res = await ApiGetVenueAdminData(data)
      setvenueAdminData(res.data)
    } catch (error) {

    }
  }

  useEffect(() => {
    (storage.getItem('userRole') === 'venueadmin' || venues) && venues && venueAdmin()
  }, [month, venues])

  const getcomplimetreport = async () => {
    try {
      const data = `?year=${month.year()}&clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
      if (shouldSkip('complient-report', data)) return;
      setcompliment([])
      const res = await ApiComplimentReport(data)
      if (res.data) {
        setcompliment(res.data)
      }
    } catch (error) {

    }
  }
  useEffect(() => {
    clientEntity && month && getcomplimetreport()
  }, [clientEntity, venues, month, isWholeGroup])

  console.log("Data", compliment)

  const AldiRegionRanking = async () => {
    const data = `?year=${reportyear.year()}&clientEntityId=${storage.getItem('clientEntityId')}${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
    try {
      const response = await ApiAldiRegionRanking(data)
      if (response.data) {
        setRegionRanking(response.data)
      }

    } catch (error: any) {
      // toast.error(error)
    }
  }

  useEffect(() => {
    if (!(clientEntity && month)) return;
    const data = `?month=${month.month() + 1}&year=${month.year()}&clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}${venues ? `&venueId=${venues}` : ''}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
    if (shouldSkip('dashboard', data)) return;
    const getapi = async () => {
      if (month) {
        try {
          // const data = {
          //   year: month.year(),
          //   month: month.month() + 1,
          //   clientEntityId: storage.getItem('clientEntityId'),
          //   ...(venues && {venueId:venues}),

          // }
          const response = await ApiDashboard(data)
          const response2 = await ApiVenuePerformance(data)
          setdashboard(response.data)
          setvenueperformance(response2)
          // toast.success(response2.message)
        }
        catch (error) {
          console.log(error)
        }
      }
    }
    clientEntity && month && getapi()
  }, [month, venues, clientEntity, isWholeGroup])

  useEffect(() => {
    clientEntity && month && console.log("Events", month, venues, clientEntity, isWholeGroup)
  }, [month, clientEntity, isWholeGroup])

  useEffect(() => {
    setreportyear(dayjs(selectedMonth))
    setmonth(dayjs(selectedMonth))
  }, [selectedMonth])


  useEffect(() => {
    const RegionList = async () => {
      if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
        const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

        const response3 = await ApiRegionVenues(data)
        dispatch(setRegion(response3.data))
      }
    }
    RegionList()
  }, [clientEntity])

  useEffect(() => {
    if (Regions.length > 0 && !selectedRegion) {
      setselectedRegion(Regions[0].regionId);
      setvenuelist(Regions[0].venues)
      // setvenues(Regions[0].venues[0].venueId)
    }
  }, [Regions, clientEntity]);

  useEffect(() => {
    const Venuelist = async () => {
      if (!window.location.hostname.includes('aldi')) {
        try {
          const clientEntityId: any = isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')
          if (shouldSkip('venueList', clientEntityId)) return;
          const response = await ApiGetVenueList(clientEntityId);
          console.log(response)
          setvenuelist(response.data);
          if (response.data.length > 0) {
            // setvenues(response.data[0].venueId)
          }
        } catch (error: any) {
          // toast.error(error)
        }
      }
      else {
        const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
        setvenuelist(finalregion)
        if (finalregion && finalregion.length > 0) {
          // setvenues(finalregion[0].venueId)
        }

      }

    };
    clientEntity && Venuelist();

  }, [selectedRegion, clientEntity, isWholeGroup])

  const handleVenueDashboard = (venueId: string, venueName: string) => {
    if (!venueId) {
      // window.alert("Invalid Access")
      return
    }
    const url = `/maindashboard/sitedashboard?v=${encodeURIComponent(venueId)}&n=${encodeURIComponent(venueName)}&s=${encodeURIComponent(selectedMonth)}`;
    window.open(url, '_blank'); // opens in new tab
  };

  const getDifferenceStyle = (difference: number | string | undefined | null) => {
    const value = Number(difference ?? 0);

    return {
      value: value.toFixed(2),
      color: value > 0 ? "var(--primary-color)" : "#BF613B",
      background: value > 0
        ? "var(--primary-light-main-color)"
        : "#BF613B1A",
    };
  };
  const getScoreByCategory = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardScoreByCategory(data)
      setData2((prev: any) => ({
        ...prev,
        sbc: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getScoreTrend = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardScoreTrend(data)
      setData2((prev: any) => ({
        ...prev,
        st: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getScoreratingSummary = async () => {
    setShowLoading(true)
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardStarRatingSummary(data)
      setData2((prev: any) => ({
        ...prev,
        srs: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
    finally {
      setShowLoading(false)
    }
  }

  const getLowestScoringQuestions = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}&isViewAll=false${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetDashboardLowestScoringQuestions(data)
      setData2((prev: any) => ({
        ...prev,
        lsq: res?.data,
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getCategoryHeatMap = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetCategoryHeatMap(data)
      setData2((prev: any) => ({
        ...prev,
        chp: res?.data || [],
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getRecentReport = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetRecentReports(data)
      setData2((prev: any) => ({
        ...prev,
        rr: res?.data || [],
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getScoreDistribution = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=${storage.getItem('userRole') === 'venueadmin' ? "true" : isSDYTD}${venues ? `&venueId=${venues}` : ""}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ""}`
      const res = await ApiGetScoreDistribution(data)
      if (storage.getItem('userRole') === 'clientadmin') {
        setClientData((prev: any) => ({
          ...prev,
          sd: res?.data || [],
        }));
      }
      setData2((prev: any) => ({
        ...prev,
        sd: res?.data || [],
      }));
    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getStarRatingAverage = async () => {
    try {
      // const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=false`
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=${isSRYTD}`
      const res = await ApiGetStarRatingAverage(data)
      setClientData((prev: any) => ({
        ...prev,
        sra: res?.data || [],
      }));

    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getVenueLeaderBoard = async () => {
    try {
      // const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=false`
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=${isSLYTD}`
      const res = await ApiGetVenueLeaderBoard(data)
      setClientData((prev: any) => ({
        ...prev,
        vlb: res?.data || [],
      }));

    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getVenueLeaderBoardDetails = async (venueId: number) => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=${isSLYTD}&venueId=${venueId}`
      const res = await ApiGetVenueLeaderBoardDetails(data)
      setClientData((prev: any) => ({
        ...prev,
        vlbd: res?.data || [],
      }));
      setopenVenueDetails(true)

    } catch (error: any) {
      toast.error(error?.message)
    }
  }
  const getCategoryScores = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}`
      const res = await ApiGetCategoryScores(data)
      setClientData((prev: any) => ({
        ...prev,
        cs: res?.data || [],
      }));

    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  const getQuestionsForBusiness = async () => {
    try {
      const data = `?clientEntityId=${isWholeGroup ? clientEntityIds : storage.getItem('clientEntityId')}&month=${month.month() + 1}&year=${month.year()}&isYTDScore=${isYTD}`
      const res = await ApiGetQuestionListForBusness(data)
      setClientData((prev: any) => ({
        ...prev,
        qlbt: res?.data?.topQuestions || [],
        qlbb: res?.data?.bottomQuestions || [],
      }));

    } catch (error: any) {
      toast.error(error?.message)
    }
  }

  useEffect(() => {
    if (storage.getItem('userRole') === 'venueadmin') {
      venues && getScoreByCategory()
      venues && getScoreTrend()
      venues && getScoreratingSummary()
      venues && getLowestScoringQuestions()
      venues && getCategoryHeatMap()
      venues && getRecentReport()
      venues && getScoreDistribution()
    }
    else if (storage.getItem('userRole') === 'areaManager') {
      clientEntity && getScoreByCategory()
      clientEntity && getScoreTrend()
      clientEntity && getScoreratingSummary()
      clientEntity && getLowestScoringQuestions()
      clientEntity && getCategoryHeatMap()
      clientEntity && getRecentReport()
      clientEntity && getScoreDistribution()
    }
    else if (storage.getItem('userRole') === 'clientadmin') {
      clientEntity && getScoreDistribution()
      clientEntity && getStarRatingAverage()
      clientEntity && getVenueLeaderBoard()
      clientEntity && getCategoryScores()
      clientEntity && getQuestionsForBusiness()
    }
  }, [categoryVenue, month, venues, clientEntity])


  useEffect(() => {
    clientEntity && getQuestionsForBusiness()
  }, [isYTD])
  useEffect(() => {
    clientEntity && getScoreDistribution()
  }, [isSDYTD])
  useEffect(() => {
    clientEntity && getVenueLeaderBoard()
  }, [isSLYTD])
  useEffect(() => {
    clientEntity && getStarRatingAverage()
  }, [isSRYTD])

  const sbcPage = getPage('sbc');
  const sbcTotalPages = getTotalPages('sbc', data2?.sbc);
  const sbcPaginatedData = getPaginatedData('sbc', data2?.sbc?.length > 0 ? data2?.sbc : []);

  const lsqPage = getPage('lsq');
  const lsqTotalPages = getTotalPages('lsq', data2?.lsq);
  const lsqPaginatedData = getPaginatedData('lsq', data2?.lsq?.length > 0 ? data2?.lsq : []);


  const chpPage = getPage('chp');
  const chpTotalPages = getTotalPages('chp', data2?.chp);
  const chpPaginatedData = getPaginatedData('chp', data2?.chp || []);

  const sraPage = getPage('sra');
  const sraTotalPages = getTotalPages('sra', clientData?.sra);
  const sraPaginatedData = getPaginatedData('sra', clientData?.sra?.length > 0 ? clientData?.sra : []);

  const csPage = getPage('cs');
  const csTotalPages = getTotalPages('cs', clientData?.cs);
  const csPaginatedData = getPaginatedData('cs', clientData?.cs || []);

  const qlbtPage = getPage('qlbt');
  const qlbtTotalPages = getTotalPages('qlbt', clientData?.qlbt);
  const qlbtPaginatedData = getPaginatedData('qlbt', clientData?.qlbt || []);

  const qlbbPage = getPage('qlbb');
  const qlbbTotalPages = getTotalPages('qlbb', clientData?.qlbb);
  const qlbbPaginatedData = getPaginatedData('qlbb', clientData?.qlbb || []);

  return (
    <Box className='h-100' height='fit-content'>
      {/* <Box className='d-flex justify-content-end'>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker sx={{ maxWidth: "120px" }} value={month} className='month-select  month-select2 txt-white'
            views={['month', 'year']}
            format="MMM-YY"
            // onChange={(e:any) => { setmonth(e?.startOf('month')); }}
            onChange={(e: any) => {
              const isoString = e?.startOf('month').toISOString();
              dispatch(setSelectedMonth(isoString));
            }}
            slots={{
              openPickerIcon: ArrowDropDownIcon,
            }}
          />
        </LocalizationProvider>
      </Box> */}
      <Box className="row  mb-3 gap-2 m-0 justify-content-between d-flex">
        <Box className='d-flex align-items-center gap-3 justify-content-end'>
          {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") === "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && storage.getItem('userRole') === 'clientadmin' && (
            <Box className='col-grow justify-content-end d-flex'>
              <FormControlLabel
                control={
                  <Switch
                    checked={isWholeGroup}
                    onChange={(e) => dispatch(setisWholeGroup(e.target.checked))}
                  />
                }
                label={"Whole Group"}
              />
            </Box>)}
          {storage.getItem('userRole') === 'venueadmin' && (<Box display={'flex'} className='pe-3 justify-content-end gap-2 align-items-center' gap={{ xs: 5, lg: 2 }}>
            {window.location.hostname.includes('aldi') && (
              Regions?.length > 1 && (<FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                <Autocomplete
                  options={Regions || []}
                  getOptionLabel={(option) => option.regionName || ''}
                  value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                  onChange={(event, newValue) => {
                    setselectedRegion(newValue?.regionId || '');
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Region"
                      variant="outlined"
                      sx={{ input: { color: 'black' } }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                />
              </FormControl>
              )
            )}
            {venuelist?.length > 1 && (<FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
              <Autocomplete
                className='text-dark'
                options={venuelist || []}
                getOptionLabel={(option) => option.venueName || ''}
                value={venuelist?.find((item) => item.venueId === venues) || null}
                onChange={(event, newValue) => {
                  setvenues(newValue?.venueId || '');
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Sites" sx={{ color: 'black !important' }} variant="outlined" />
                )}

                isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
              />
            </FormControl>
            )}
          </Box>
          )}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker sx={{ maxWidth: "120px" }} value={month} className='month-select  month-select2'
              views={['month', 'year']}
              format="MMM-YY"
              // onChange={(e:any) => { setmonth(e?.startOf('month')); }}
              onChange={(e: any) => {
                const isoString = e?.startOf('month').toISOString();
                dispatch(setSelectedMonth(isoString));
              }}
              slots={{
                openPickerIcon: ArrowDropDownIcon,
              }}
            />
          </LocalizationProvider>
        </Box>
        {/* ------------------------------------------------------- Customer Experience ----------------------------------------------------------- */}

        {/* <Box width={{ md: '58%', xs: "100%" }} padding={{ xs: 2, md: 3 }} className=" border-10 bg-main">
          <Box className='d-flex white-select  align-items-center justify-content-between'>
            <Box width={{ xs: '25%', md: 'auto' }}>
              <Box component='img' src={profile} width={{ md: '30%', xs: '70%' }} />
              <Typography className='mt-2 fw-bold w-75 txt-white' fontSize={{ xs: '14px', md: '16px' }}>Customer Experience Score</Typography>
            </Box>
            <Box width={{ xs: '75%', md: 'auto' }} className='d-flex flex-column align-items-end'>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker value={month} className='month-select  month-select2 txt-white'
                  views={['month', 'year']}
                  format="MMM-YY"
                  // onChange={(e:any) => { setmonth(e?.startOf('month')); }}
                  onChange={(e: any) => {
                    const isoString = e?.startOf('month').toISOString();
                    dispatch(setSelectedMonth(isoString));
                  }}
                  slots={{
                    openPickerIcon: ArrowDropDownIcon,
                  }}
                />
              </LocalizationProvider>
              <Typography className='mt-0 text-end txt-white' fontWeight='900' fontSize={{ xs: '28px', md: '32px' }}>{dashboard ? parseFloat(dashboard?.currentMonth?.avgScore).toFixed(2) : '-/-'}%</Typography>
              <Typography variant='caption' className='text-end txt-white'><ArrowOutward sx={{ color: "white", height: '18px' }} /> <span style={{ color: "white" }} className='fw-bold'>{dashboard ? parseFloat(dashboard?.difference).toFixed(2) : '-/-'}%</span> from last month</Typography>
            </Box>
          </Box>
        </Box> */}
        <Grid container alignItems={'stretch'} spacing={2}>
          <Grid size='grow'>
            <Box className="border-10 px-3 py-2 h-100" bgcolor={"var(--primary-color)"} border={'1px solid var(--primary-color)'}>
              <Box className='d-flex white-select align-items-center justify-content-between gap-2'>
                <Box className='d-flex align-items-center gap-2 w-100'>
                  <Box component='img' src={profile} maxWidth={'70px'} />
                  <Box>
                    <Typography className='fw-bold txt-white' fontSize={{ xs: '14px', md: '16px' }} gutterBottom>Customer Experience Score</Typography>
                    <Box className='d-flex align-items-baseline flex-wrap gap-2'>
                      <Typography className='mt-0 txt-white' fontWeight='900' fontSize={{ xs: '28px', md: '36px' }}>{dashboard ? parseFloat(dashboard?.currentMonth?.avgScore).toFixed(2) : '-/-'}%</Typography>
                      <Typography variant='body2' className='txt-white' whiteSpace={'nowrap'}>{Number(getDifferenceStyle(dashboard?.difference).value) > 0 ? <NorthOutlined sx={{ fontSize: '14px' }} /> : <SouthOutlined sx={{ fontSize: '14px' }} />}<span className='fw-bold'>{dashboard ? parseFloat(dashboard?.difference).toFixed(2) : '-/-'}%</span> from last month</Typography>
                    </Box>
                  </Box>

                </Box>
                <Box flex={1} className='d-flex flex-column align-items-end'>
                  {/* <Box className='w-100 h-100'>
                {dashboard?.lastSixMonthsAvgScore?.length > 0 && (<TrendChart trend={dashboard?.lastSixMonthsAvgScore?.map((item: any) => Number(item?.avgScore))} />)}
              </Box> */}
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker value={month} className='month-select  month-select2 txt-white'
                  views={['month', 'year']}
                  format="MMM-YY"
                  // onChange={(e:any) => { setmonth(e?.startOf('month')); }}
                  onChange={(e: any) => {
                    const isoString = e?.startOf('month').toISOString();
                    dispatch(setSelectedMonth(isoString));
                  }}
                  slots={{
                    openPickerIcon: ArrowDropDownIcon,
                  }}
                />
              </LocalizationProvider> */}

                </Box>
              </Box>
            </Box>
          </Grid>
          {/* ------------------------------------------------------- Total Ratings ----------------------------------------------------------- */}
          {/* 
        {
          storage.getItem('userRole') === 'venueadmin' || venues ?
            (<Box width={{ md: '20%', xs: "48%" }} padding={{ xs: 2, md: 3 }} className="d-flex align-items-start justify-content-between bg-secondary border-10">
              <Box className='d-flex align-items-start h-100  flex-column justify-content-between'>
                <Typography className='fw-bold' whiteSpace='wrap'>Company Average Score</Typography>
                <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{(storage?.getItem("ISC") == "1" && storage.getItem('userRole') === 'venueadmin') ? "N/A" : parseFloat(venueAdminData?.companyAvgScore).toFixed(2)}</Typography>
              </Box>
            </Box>
            ) :

            (compliment?.avgStarRating && isratingJson) ? (<Box width={{ md: '20%', xs: "48%" }} padding={{ xs: 2, md: 3 }} className="d-flex align-items-start justify-content-between bg-secondary border-10">
              <Box className='d-flex align-items-start h-100  flex-column justify-content-between'>
                <Typography className='fw-bold' whiteSpace='wrap'>Star<br /> Rating Average</Typography>
                <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{compliment?.avgStarRating ?? '-/-'}</Typography>
              </Box>
              <IconButton onClick={() => { navigate('/maindashboard/reports/reportstarrating'); storage.setItem('ActiveTask', "Reports") }} className='bg-white send-btn p-4' >
                <ArrowOutward />
              </IconButton>
            </Box>)
              :
              (<Box width={{ md: '20%', xs: "48%" }} padding={{ xs: 2, md: 3 }} className="d-flex align-items-start justify-content-between bg-secondary border-10">
                <Box className='d-flex align-items-start h-100  flex-column justify-content-between'>
                  <Typography className='fw-bold' whiteSpace='wrap'>{(storage.getItem('userRole') === "clientadmin" && !venues) ? "Company" : "Area"}<br /> Average (YTD)</Typography>
                  <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{compliment?.companyYTDScore ?? '-/-'}</Typography>
                </Box>
              </Box>
              )
        } */}
          <Grid size='grow'>
            {
              storage.getItem('userRole') === 'venueadmin' || venues ?
                (<Box className="d-flex align-items-center px-3 py-2 justify-content-between  h-100 border-10 bg-secondary" >
                  <Box className='d-flex align-items-center  gap-3'>
                    <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                      <Business sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                    </Box>
                    <Box>
                      <Typography className='fw-bold' whiteSpace='wrap'>Company Average Score</Typography>
                      <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{(storage?.getItem("ISC") == "1" && storage.getItem('userRole') === 'venueadmin') ? "N/A" : parseFloat(venueAdminData?.companyAvgScore).toFixed(2)}</Typography>
                    </Box>
                  </Box>

                </Box>
                ) :

                (compliment?.avgStarRating && isratingJson) ? (
                  <Box className="d-flex px-3 h-100 py-2 align-items-start justify-content-between border-10 bg-secondary">
                    <Box className='d-flex align-items-center h-100 gap-3'>
                      <Box className='m-0'>
                        <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                          <Star sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                        </Box>
                      </Box>
                      <Box>
                        <Typography className='fw-bold' whiteSpace='wrap'>Star Rating Average</Typography>
                        <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{compliment?.avgStarRating ?? '-/-'}</Typography>
                      </Box>
                    </Box>
                    <IconButton onClick={() => { navigate('/maindashboard/reports/reportstarrating'); storage.setItem('ActiveTask', "Reports") }} className='p-2' sx={{ border: '1px solid black', borderRadius: '15px' }}>
                      <ArrowOutward />
                    </IconButton>
                  </Box>)
                  :
                  (<Box className="d-flex align-items-center h-100 px-3 py-2 justify-content-between border-10 bg-secondary">
                    <Box className='d-flex align-items-center gap-3'>
                      <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                        <Business sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                      </Box>
                      <Box>
                        <Typography className='fw-bold' whiteSpace='wrap'>{(storage.getItem('userRole') === "clientadmin" && !venues) ? "Company" : "Area"}<br /> Average (YTD)</Typography>
                        <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{compliment?.companyYTDScore ?? '-/-'}</Typography>
                      </Box>
                    </Box>
                  </Box>
                  )
            }
          </Grid>


          {/* ------------------------------------------------------- Total Visits ----------------------------------------------------------- */}
          {/* {storage.getItem('userRole') !== 'venueadmin' ?
          (<Box width={{ md: '20%', xs: "48%" }} padding={{ xs: 2, md: 3 }} className="d-flex align-items-start justify-content-between bg-third border-10">
            <Box className='d-flex align-items-start h-100  flex-column justify-content-between'>
              <Typography className='fw-bold w-25' whiteSpace='wrap'>Achieving  {storage.getItem('ClientGroupName') === "TRANSPORT" ? "Networks" : 'Sites'}</Typography>
              <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{compliment?.compliantCount ?? '0'}/{compliment?.totalReports ?? '0'}</Typography>
            </Box>
            <IconButton onClick={() => { navigate('/maindashboard/reports/groupmonthlysitescore'); storage.setItem('ActiveTask', "Reports") }} type='submit' className='bg-white send-btn p-4'>
              <ArrowOutward />
            </IconButton>

          </Box>) :
          (<Box width={{ md: '20%', xs: "48%" }} padding={{ xs: 2, md: 3 }} className="d-flex align-items-start justify-content-between bg-third border-10">
            <Box className='d-flex align-items-start h-100  flex-column justify-content-between'>
              <Typography className='fw-bold w-25' whiteSpace='wrap'>YTD Average Score</Typography>
              <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{venueAdminData?.ytdScore}</Typography>
            </Box>
          </Box>)} */}
          <Grid size={'grow'}>
            {storage.getItem('userRole') !== 'venueadmin' ?
              (
                <Box className="d-flex align-items-start h-100 px-3 py-2 justify-content-between border-10 bg-third">
                  <Box className='d-flex align-items-center h-100 gap-3'>
                    <Box className='m-0' bgcolor={'var(--third-medium-color)'} sx={{ borderRadius: '50px' }} >
                      <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                        <EmojiEvents sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                      </Box>
                    </Box>
                    <Box>
                      <Typography className='fw-bold' whiteSpace='wrap'>Achieving {storage.getItem('ClientGroupName') === "TRANSPORT" ? "Networks" : 'Sites'}</Typography>
                      <Typography fontSize={{ xs: '28px', md: '36px' }} fontWeight='900'>{compliment?.compliantCount ?? '0'}/{compliment?.totalReports ?? '0'}</Typography>
                    </Box>
                  </Box>
                  <IconButton onClick={() => { navigate('/maindashboard/reports/groupmonthlysitescore'); storage.setItem('ActiveTask', "Reports") }} className='p-2' sx={{ border: '1px solid black', borderRadius: '15px' }}>
                    <ArrowOutward />
                  </IconButton>
                </Box>) :
              (
                <Box className="d-flex align-items-center h-100 px-3 py-2 justify-content-between border-10 bg-third">
                  <Box className='d-flex align-items-center gap-3'>
                    <Box sx={{ background: '#FFFFFF1A' }} className='p-3' borderRadius={'50px'}>
                      <EmojiEvents sx={{ fontSize: { xs: '36px', md: '52px' } }} className='text-white' />
                    </Box>
                    <Box>
                      <Typography className='fw-bold' whiteSpace='wrap'>YTD Average Score</Typography>
                      <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{venueAdminData?.ytdScore}</Typography>
                    </Box>
                  </Box>
                </Box>
              )}
          </Grid>
          {dashboard?.businessNPSScore && isShowNPS && (<Grid size={"grow"}>
            <Box className="d-flex align-items-start h-100 px-3 py-2 justify-content-between border-10" bgcolor={'#c7a456'}>
              <Box className='d-flex align-items-center h-100 gap-3'>
                <Box sx={{ background: '#FFFFFF1A', cursor: 'pointer' }} className='p-2' borderRadius={'50px'}>
                  <Box component={'img'} src={npsicon} height={'65px'}></Box>
                </Box>
                <Box>
                  <Typography className='fw-bold' whiteSpace='wrap'>Net Promoter Score</Typography>
                  <Typography fontSize={{ xs: '28px', md: '32px' }} fontWeight='900'>{dashboard?.businessNPSScore}/10</Typography>
                </Box>
              </Box>
              <IconButton onClick={() => { navigate('/maindashboard/comparisionReports/netpromoterscore'); storage.setItem('ActiveTask', "Comparisons") }} className='p-2' sx={{ border: '1px solid black', borderRadius: '15px' }}>
                <ArrowOutward />
              </IconButton>
            </Box>
          </Grid>
          )}
        </Grid>
      </Box>

      {/* --------------------------------------------------------------- middle Line ------------------------------------------ */}
      <Box className='d-flex flex-wrap my-3 mt-5 w-100  align-items-stretch' alignItems='stretch' gap={2}>
        {storage.getItem('clientEntityName') !== 'Liquor ID' &&
          ((storage.getItem('userRole') !== 'venueadmin' && !venues) ? (
            <Box sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(venueperformance?.topPerformingSite?.venueId, venueperformance?.topPerformingSite?.venueName) }} position='relative' flex={1} height="100%" border-10 p={{ xs: 2, md: 3 }} className='d-flex hover border d-flex flex-column align-items-start justify-content-between h-100 border-10' gap={3}>
              <Typography>Top <br></br> Performing {storage.getItem('ClientGroupName') !== "TRANSPORT" && "Site"}</Typography>
              <Typography className='text-blue fw-bold'>{venueperformance?.topPerformingSite?.venueName ?? 'N/A'}</Typography>
              <Box component='img' position='absolute' top={-30} right={-10} src={m1} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'}></Box>
            </Box>) :
            (storage.getItem("ISC") != "1" && (<Box position='relative' flex={1} height="100%" p={{ xs: 2, md: 3 }} className='d-flex border d-flex flex-column align-items-start justify-content-between h-100 border-10' gap={3}>
              <Typography>Last<br></br> Month Rank</Typography>
              <Typography className='text-blue fw-bold'>Your rank {venueAdminData?.monthlyRanking?.rank ?? 'N/A'} out of {venueAdminData?.monthlyRanking?.outOf > 0 ? venueAdminData?.monthlyRanking?.outOf : 'N/A'}</Typography>
              <Box component='img' position='absolute' top={-30} right={-10} src={m1} width={{ xs: '30%', md: '20%' }}></Box>
            </Box>)))}

        {storage.getItem('clientEntityName') !== 'Liquor ID' && (<Box position='relative' flex={1} height="100%" border-10 p={{ xs: 2, md: 3 }} className='d-flex  border  d-flex flex-column align-items-start justify-content-between h-100  border-10' gap={3}>
          <Typography className='w-25'>Biggest Opportunity</Typography>
          <Typography className='text-main fw-bold '>{venueperformance?.BottomPerformingCategory?.categoryName ?? 'N/A'}</Typography>
          <Box component='img' position='absolute' top={-30} right={-10} src={m2} width={{ xs: '40%', md: '20%' }} maxWidth={'100px'}></Box>
        </Box>)}
        {storage.getItem('clientEntityName') !== 'Liquor ID' &&
          ((storage.getItem('userRole') !== 'venueadmin' && !venues) ?
            (
              <Box position='relative' sx={{ cursor: 'pointer' }} onClick={() => { handleVenueDashboard(venueperformance?.lowPerformingSite?.venueId, venueperformance?.lowPerformingSite?.venueName) }} flex={1} height="100%" border-10 p={{ xs: 2, md: 3 }} className='d-flex border hover  d-flex flex-column align-items-start justify-content-between h-100  border-10' gap={3}>
                <Typography>Below <br></br> Benchmark {storage.getItem('ClientGroupName') !== "TRANSPORT" && "Site"}</Typography>
                <Typography className='text-blue fw-bold'>{venueperformance?.lowPerformingSite?.venueName ?? 'N/A'}</Typography>
                <Box component='img' position='absolute' top={-30} right={-10} src={m3} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'} ></Box>
              </Box>) :
            (
              storage.getItem("ISC") != "1" && (<Box position='relative' flex={1} height="100%" border-10 p={{ xs: 2, md: 3 }} className='d-flex border  d-flex flex-column align-items-start justify-content-between h-100  border-10' gap={3}>
                <Typography>YTD<br></br>Rank</Typography>
                <Typography className='text-blue fw-bold'>Your rank {venueAdminData?.ytdRanking?.rank ?? '-'} out of {venueAdminData?.ytdRanking?.outOf ?? '-'}</Typography>
                <Box component='img' position='absolute' top={-30} right={-10} src={m3} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'}></Box>
              </Box>)))}

        {storage.getItem('clientEntityName') !== 'Liquor ID' && (<Box position='relative' flex={1} height="100%" border-10 p={{ xs: 2, md: 3 }} className='d-flex border  d-flex flex-column align-items-start justify-content-between h-100 border-10' gap={3}>
          <Typography>Your <br></br> Biggest Strength</Typography>
          <Typography className='text-main fw-bold'>{venueperformance?.TopPerformingCategory?.categoryName ?? 'N/A'}</Typography>
          <Box component='img' position='absolute' top={-30} right={-10} src={m4} width={{ xs: '30%', md: '20%' }} maxWidth={'100px'}></Box>
        </Box>)}
      </Box>

      {(storage.getItem('userRole') === 'venueadmin' || storage.getItem('userRole') === 'areaManager') && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: (((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating ) ? 6 : 12), xl: (((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating) ? 6 : 4) }}>
            <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
              <Grid container alignItems={'center'} className='p-3 mm-card-gradient' justifyContent={'space-between'}>
                <Grid size={'auto'}>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='p-1 border-10 bg-main'>
                      <Category className='text-white' />
                    </Box>
                    <Typography className='text-dark fw-bold'>Score by Category</Typography>
                  </Box>
                </Grid>
                <Grid size={'auto'}>
                  <Box className='d-flex align-items-center gap-3'>
                    <Box className='d-flex align-items-center gap-1'>
                      <Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                      <Typography variant='caption' className='text-dark'>Your Score</Typography>
                    </Box>
                    <Box className='d-flex align-items-center gap-1'>
                      <Box className='bg-secondary' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                      <Typography variant='caption' className='text-dark'>Company Avg</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Box flex={1} className='p-3 d-flex flex-column'>
                {sbcPaginatedData?.length > 0 ? (
                  <Box flex={1}>
                    {
                      sbcPaginatedData?.map((item: any, index: number) => (
                        <Box className='mb-3'>
                          <Grid container alignItems={'center'} spacing={2} className='w-100'>
                            <Grid size={4}>
                              <Typography variant='body2' className='text-dark'>{item?.categoryName}</Typography>
                            </Grid>
                            <Grid size={'grow'}>
                              <Box className='w-100'>
                                <Box className='d-flex align-items-center gap-2'>
                                  <Box flex={1}>
                                    <LinearProgress
                                      variant="determinate"
                                      value={item?.venueScore || 0}
                                      aria-label="Export data"
                                      sx={{
                                        height: 10,
                                        borderRadius: 5,
                                        backgroundColor: "var(--primary-light-main-color)",
                                        "& .MuiLinearProgress-bar": {
                                          background: "var(--primary-color)",
                                          borderRadius: 5,
                                        },
                                      }}
                                    />
                                  </Box>
                                  <Typography className='d-block m-0 p-0 text-dark' variant='caption'>{item?.venueScore}%</Typography>
                                </Box>
                                <Box className='d-flex align-items-center gap-2'>
                                  <Box flex={1}>
                                    <LinearProgress
                                      className='mt-1'
                                      variant="determinate"
                                      value={item?.businessScore || 0}
                                      aria-label="Export data"
                                      sx={{
                                        height: 10,
                                        borderRadius: 5,
                                        backgroundColor: "var(--secondary-light-color)",
                                        "& .MuiLinearProgress-bar": {
                                          background: "var(--secondary-color)",
                                          borderRadius: 5,
                                        },
                                      }}
                                    />
                                  </Box>
                                  <Typography className='d-block m-0 p-0 text-dark' variant='caption'>{item?.businessScore}%</Typography>
                                </Box>
                              </Box>
                            </Grid>
                            <Grid size={2} className='d-flex justify-content-end'>
                              <Typography className='fw-bold' variant='caption'>{Number(getDifferenceStyle(item?.change).value) > 0 ? <ArrowDropUp sx={{ color: getDifferenceStyle(item?.change).color }} /> : <ArrowDropDown sx={{ color: getDifferenceStyle(item?.change).color }} />}<span style={{ color: getDifferenceStyle(item?.change).color }} className='fw-bold'>{item?.change}%</span></Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      ))
                    }

                  </Box>
                ) : (
                  <Box className='d-flex h-100 align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>)}
                {sbcTotalPages > 1 ? (
                  <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                      page={sbcPage}
                      sx={{
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: 'var(--primary-color)'
                        }
                      }}
                      count={sbcTotalPages}
                      color="primary"
                      onChange={(_, value) => setPage('sbc', value)}
                    />
                  </Box>
                ) : ("")}
              </Box>
            </Box>
          </Grid>
          {(storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating  ? (
            <Grid size={{ xs: 12, md: 6, xl: 6 }}>
              <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
                <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between'>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='p-1 border-10 bg-main'>
                      <Star className='text-white' />
                    </Box>
                    <Typography className='text-dark fw-bold m-0 p-0'>Star Ratings Summary</Typography>
                  </Box>
                  {JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating ? (<Link to={'/maindashboard/reports/reportstarrating'} className='text-main'>View Details</Link>) : (<></>)}
                </Box>
                <Box flex={1} className='p-3 pt-0'>
                  {showLoading ? (
                    <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                  ) :
                    data2?.srs?.length > 0 ? (
                      <Box>
                        <Grid container alignItems={'center'} sx={{
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            right: 0,
                            bottom: 0,
                            height: "1px",
                            background: `repeating-linear-gradient(
                              to right,
                             #00000040 0px,
                             #00000040 12px,
                          transparent 12px,
                          transparent 20px
                          )`,
                          }, py: '12px',
                          marginBottom: '15px'
                        }} spacing={2}>
                          <Grid size={4}>
                            <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Category Name</Typography>
                          </Grid>
                          <Grid size={3}>
                            <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Ratings</Typography>
                          </Grid>
                          <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'></Typography></Grid>
                          <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>Com. Avg</Typography></Grid>
                          <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>Ind. Avg</Typography></Grid>
                          <Grid size='grow'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'>Change</Typography></Grid>
                        </Grid>
                        {
                          data2?.srs?.map((item: any) => (
                            <Box className='mb-3'>
                              <Grid container alignItems={'center'} spacing={2}>
                                <Grid size={4}>
                                  <Typography variant='body2' className='text-dark m-0 p-0'>{item?.categoryName}</Typography>
                                </Grid>
                                <Grid size={3}>
                                  <Rating name="half-rating" sx={{ flex: 1, color: 'var(--primary-color)' }} className='m-0 p-0' defaultValue={item?.venueScore} readOnly />
                                </Grid>
                                <Grid size='grow' className='d-flex align-items-center gap-1'><Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.venueScore}</Typography></Grid>
                                <Grid size='grow' className='d-flex align-items-center gap-1'><Box className='bg-secondary' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.businessScore}</Typography></Grid>
                                <Grid size='grow' className='d-flex align-items-center gap-1'><Box className='bg-third' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.industryAverage}</Typography></Grid>
                                <Grid size='grow'><Typography variant='body2' className='text-dark text-center m-0 p-0 fw-bold' sx={{ color: `${getDifferenceStyle(item?.change).color} !important` }}> {item?.change > 0 ? "+" : ""}{item?.change}</Typography></Grid>
                              </Grid>
                            </Box>
                          ))
                        }
                      </Box>
                    ) : (
                      <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                    )
                  }
                </Box>
              </Box>
            </Grid>
          ):(<></>)}
          <Grid size={{ xs: 12, md: (storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED" ? 6 : 6), xl: (((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating) ? 6 : 4) }}>
            <Box className='border h-100 border-main border-10 overflow-hidden'>
              <Box className='d-flex align-items-center justify-content-between mm-card-gradient mb-2 p-3'>
                <Box className='d-flex align-items-center gap-2'>
                  <Box className='p-1 border-10 bg-main'>
                    <DonutLarge className='text-white' />
                  </Box>
                  <Typography className='text-dark fw-bold'>Score Distribution</Typography>
                  <Typography className='text-dark' variant='caption'>(All reports YTD)</Typography>
                </Box>
              </Box>
              {data2?.sd?.distribution?.length > 0 && (
                <Box className='p-0 pe-4'>
                  <DonutChart data2={data2?.sd} />
                </Box>
              )}
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: (((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating) ? 6 : 6), xl: (((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") && JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating) ? 6 : 4) }}>
            <Box className='border border-main border-10 overflow-hidden'>
              <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between mb-2'>
                <Box className='d-flex align-items-baseline gap-1'>
                  <Box className='p-1 border-10 bg-main'>
                    <TrendingUp className='text-white' />
                  </Box>
                  <Typography className='text-dark fw-bold'>Score Trend</Typography>
                  <Typography className='text-dark' variant='caption'>(Last 6 Months)</Typography>
                </Box>
                <Box className='d-flex align-items-center gap-2'>
                  <Box className='d-flex align-items-center gap-1'>
                    <Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                    <Typography variant='caption' className='text-dark'>Your Score</Typography>
                  </Box>
                  <Box className='d-flex align-items-center gap-1'>
                    <Box className='bg-secondary' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                    <Typography variant='caption' className='text-dark'>Company Avg</Typography>
                  </Box>
                </Box>
              </Box>
              <Box className='p-3'>
                {data2?.st && (<DoubleLineChart data={data2?.st?.length > 0 ? data2?.st : []} />)}
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 12, xl: 12 }}>
            <Box className="border d-flex flex-column border-main border-10 h-100 overflow-hidden">
              <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                <Box className="d-flex gap-2">
                  <Box className='p-1 border-10 bg-main'>
                    <QuestionMark className='text-white' />
                  </Box>
                  <Typography className="fw-bold text-dark fw-bold">
                    Lowest Scoring Questions
                  </Typography>
                </Box>
                <Link to={'/maindashboard/reports/questionsummaryreport'} className='text-main'>View Details</Link>
              </Box>
              <Box flex={1} className='p-3 pt-0'>
                {lsqPaginatedData?.length > 0 ? (
                  <Table size="small" className='m-0 p-0'>
                    <TableHead sx={{
                      position: "relative",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: "1px",
                        background: `repeating-linear-gradient(
                              to right,
                             #00000040 0px,
                             #00000040 12px,
                          transparent 12px,
                          transparent 20px
                          )`,
                      },


                    }}>
                      <TableRow>
                        <TableCell className='m-0' sx={{ py: 3.8 }}></TableCell>
                        <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Question</Typography></TableCell>
                        <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Category</Typography></TableCell>
                        <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Your Score</Typography></TableCell>
                        <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Company Avg</Typography></TableCell>
                        <TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Gap</Typography></TableCell>
                        {storage.getItem('ClientGroupName') != "BLOOMS" && (<TableCell className='fw-bold m-0'><Typography variant='caption' className='fw-bold text-blue'>Trend</Typography></TableCell>)}
                      </TableRow>
                    </TableHead>

                    <TableBody >
                      {lsqPaginatedData?.map((row: any, index: number) => (
                        <TableRow key={row?.question}>
                          <TableCell>
                            <Typography variant='body1' className='fw-bold'>{index + 1}</Typography>
                          </TableCell>
                          <TableCell><Tooltip title={row?.question || ""} arrow>
                            <Typography
                              variant="body2"
                              sx={{
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                lineHeight: 1.5,
                                maxHeight: "3em", // 2 × 1.5em
                                width: "100%",
                                maxWidth: { lg: 450, xl: 600 },
                              }}
                            >
                              {row?.question}
                            </Typography>
                          </Tooltip>
                          </TableCell>
                          <TableCell><Typography variant='body2'>{row?.categoryName}</Typography></TableCell>
                          <TableCell><Typography variant='body2'>{row?.venuePercentage}%</Typography></TableCell>
                          <TableCell><Typography variant='body2'>{row?.businessPercentage}%</Typography></TableCell>
                          <TableCell>
                            <Typography sx={{ color: `${getDifferenceStyle(row?.gap).color} !important` }} className='fw-bold' variant='body2'>
                              {row?.gap > 0 ? "+" : ""}{row.gap}%
                            </Typography>
                          </TableCell>
                          {storage.getItem('ClientGroupName') != "BLOOMS" && (<TableCell>{row?.trend && (<Box maxWidth={'100px'}> <TrendChart trend={row?.trend} /></Box>)}</TableCell>)}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                )}
                {lsqTotalPages > 1 ? (
                  <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                      page={lsqPage}
                      sx={{
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: 'var(--primary-color)'
                        }
                      }}
                      count={lsqTotalPages}
                      color="primary"
                      onChange={(_, value) => setPage('lsq', value)}
                    />
                  </Box>
                ) : ("")}
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6, xl: 6 }}>
            <Box className="border d-flex flex-column border-main border-10 h-100 overflow-hidden">
              <Box className="d-flex gap-1 align-items-center p-3 mm-card-gradient justify-content-between">
                <Box className='d-flex align-items-baseline gap-2'>
                  <Box className='p-1 border-10 bg-main'>
                    <CalendarViewMonth className='text-white' />
                  </Box>
                  <Typography className="fw-bold text-dark">
                    Category Heatmap
                  </Typography>

                  <Typography variant="caption" className='text-dark'>
                    (Last 6 Months)
                  </Typography>
                </Box>
                <Box>
                  <Box className="d-flex gap-3 justify-content-end">
                    <Box className='d-flex align-items-center gap-1'>
                      <Box height={'15px'} width={'15px'} borderRadius={'50%'} bgcolor={"var(--primary-color)"}></Box>
                      <Typography variant="caption">
                        90-100%
                      </Typography>
                    </Box>
                    <Box className='d-flex align-items-center gap-1'>
                      <Box height={'15px'} width={'15px'} borderRadius={'50%'} bgcolor={"var(--secondary-color)"}></Box>
                      <Typography variant="caption">
                        81-89%
                      </Typography>
                    </Box>
                    <Box className='d-flex align-items-center gap-1'>
                      <Box height={'15px'} width={'15px'} borderRadius={'50%'} bgcolor={"var(--third-color)"}></Box>
                      <Typography variant="caption">
                        Below 80%
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box flex={1} className='p-3 d-flex flex-column'>

                {chpPaginatedData?.length > 0 ? (
                  <Box flex={1}>
                    <Table className='p-0' sx={{
                      borderCollapse: "separate",
                      borderSpacing: "5px 5px",
                    }} size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell className='border-0' />
                          {
                            data2?.chp?.[0]?.trend?.map((item: any) => (
                              <TableCell className='p-1 text-center'><Typography variant='body2'>{monthNames[item?.month - 1]}</Typography></TableCell>
                            ))
                          }
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {chpPaginatedData?.map((item: any, index: number) => (
                          <TableRow key={index} sx={{ alignItems: 'center' }}>
                            <TableCell className='border-0 p-1'>{item?.categoryName}</TableCell>
                            {item?.trend.map((value: any, i: number) => (
                              <TableCell
                                key={i}
                                className='border-10 border-0 p-1'
                                sx={{
                                  background:
                                    value?.venueScore >= 90
                                      ? "var(--primary-color)"
                                      : value?.venueScore >= 81
                                        ? "var(--secondary-color)"
                                        : "var(--third-color)",
                                  color:
                                    value?.venueScore >= 90
                                      ? "#FFFFFF"
                                      : value?.venueScore >= 80
                                        ? "#FFFFFF"
                                        : value?.venueScore >= 70 ? "#FFFFFF" : "#FFFFFF",
                                  textAlign: "center",
                                  fontWeight: 600,
                                }}
                              >
                                {value?.venueScore}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                ) : (<Box className='h-100 d-flex align-items-center justify-content-center'>No Data Found</Box>)}
                {chpTotalPages > 1 ? (
                  <Box display="flex" justifyContent="center" mt={2}>
                    <Pagination
                      page={chpPage}
                      sx={{
                        "& .MuiPaginationItem-root.Mui-selected": {
                          backgroundColor: 'var(--primary-color)'
                        }
                      }}
                      count={chpTotalPages}
                      color="primary"
                      onChange={(_, value) => setPage('chp', value)}
                    />
                  </Box>
                ) : ("")}
              </Box>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6, xl: 6 }}>
            <Box className="border d-flex flex-column border-main border-10 h-100 overflow-hidden">
              <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                <Box className="d-flex gap-2 align-items-center">
                  <Box className='p-1 border-10 bg-main'>
                    <Schedule className='text-white' />
                  </Box>
                  <Typography className="fw-bold text-dark ">
                    Recent Reports
                  </Typography>
                </Box>
                <Link to={'/maindashboard/scoreCard'} className='text-main'>View Details</Link>
              </Box>
              <Box flex={1} className='p-3'>
                {
                  data2?.rr?.length > 0 ? (

                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell><Typography variant='body2'>Date</Typography></TableCell>
                          <TableCell className='text-center'><Typography variant='body2'>Final Score</Typography></TableCell>
                          <TableCell className='text-center'><Typography variant='body2'>Average Score</Typography></TableCell>
                          <TableCell className='text-center'><Typography variant='body2'>Change</Typography></TableCell>
                          {storage.getItem('userRole') !== 'areaManager' && (<TableCell className='text-center'><Typography variant='body2'>Rank</Typography></TableCell>)}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {data2?.rr?.map((item: any, index: number) => (
                          <TableRow key={index}>
                            <TableCell className='py-2'><Typography variant='body2' className='fw-bold'>{monthNames[item?.month - 1]}, {item?.year}</Typography></TableCell>

                            <TableCell className='py-2 text-center'><Typography variant='body2' className='fw-bold'>{item.venueScore}</Typography></TableCell>
                            <TableCell className='py-2 text-center'><Typography variant='body2' className='fw-bold'>{item.businessScore}</Typography></TableCell>

                            <TableCell className='py-2 text-center'>
                              <Typography
                                variant='body2'
                                color={
                                  item.change >= 0
                                    ? "success.main"
                                    : "error.main"
                                }
                              >
                                {item.change}
                              </Typography>
                            </TableCell>

                            {storage.getItem('userRole') !== 'areaManager' && (<TableCell className='text-center'><Typography variant='body2'>{item.rank}/{item?.outOf}</Typography></TableCell>)}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  ) : (
                    <Box className='d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                  )}
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}

      {storage.getItem('userRole') === 'clientadmin' &&
        (
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6, xl: 6 }}>
              <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
                <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between'>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='border-10 bg-main p-1 d-flex align-items-center justify-content-center'>
                      <Star className='text-white' />
                    </Box>
                    <Typography className='text-dark fw-bold m-0 p-0'>Category Scores ({dayjs(month).format('MMM-YY')})</Typography>
                  </Box>
                    <Link to={'/maindashboard/comparisionReports/categoryreport'} className='text-main'>View Details</Link>
                </Box>
                <Box flex={1} className='p-3 pt-0'>
                  {
                    // showLoading ? (
                    //   <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                    // ) :
                    csPaginatedData?.length > 0 ? (
                      <Box>
                        <Grid container alignItems={'center'} sx={{
                          position: "relative",
                          "&::after": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            right: 0,
                            bottom: 0,
                            height: "1px",
                            background: `repeating-linear-gradient(
                              to right,
                             #00000040 0px,
                             #00000040 12px,
                          transparent 12px,
                          transparent 20px
                          )`,
                          }, py: '12px',
                          marginBottom: '15px'
                        }} spacing={2}>
                          <Grid size={4}>
                            <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Category</Typography>
                          </Grid>
                          <Grid size={'grow'} className='d-flex align-items-center gap-1 justify-content-center'>
                            <Typography variant='caption' className='text-blue text-center fw-bold m-0 p-0'>Score</Typography>
                          </Grid>
                          {/* <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'></Typography></Grid> */}
                          <Grid size='grow' className='d-flex align-items-center gap-1 justify-content-center'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>vs Last Time</Typography></Grid>
                          <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>vs Industry Avg.</Typography></Grid>
                          <Grid size='grow' className='d-flex align-items-center justify-content-center'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'>Trend</Typography></Grid>
                        </Grid>
                        {
                          csPaginatedData?.map((item: any) => (
                            <Box >
                              <Grid container alignItems={'center'} spacing={2}>
                                <Grid size={4}>
                                  <Typography variant='body2' className='text-dark m-0 p-0'>{item?.categoryName}</Typography>
                                </Grid>
                                <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Typography variant='body2' className='text-dark text-center fw-bold m-0 p-0'>{item?.score}%</Typography></Grid>
                                <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Typography variant='body2' className={`${item?.vsLastMonth >= 0 ? 'text-main' : 'text-secondary'} fw-bold text-center m-0 p-0`}>{item?.vsLastMonth}pp</Typography></Grid>
                                <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Typography variant='body2' className={`${item?.vsIndustry >= 0 ? 'text-main' : 'text-secondary'} fw-bold text-center m-0 p-0`}>{item?.vsIndustry}pp</Typography></Grid>
                                <Grid size='grow'>
                                  {item?.trendData?.length > 0 && (<TrendChart trend={item?.trendData} />)}
                                </Grid>
                              </Grid>
                            </Box>
                          ))
                        }
                      </Box>
                    ) : (
                      <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                    )
                  }
                  {csTotalPages > 1 ? (
                    <Box display="flex" justifyContent="center" mt={2}>
                      <Pagination
                        page={csPage}
                        sx={{
                          "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: 'var(--primary-color)'
                          }
                        }}
                        count={csTotalPages}
                        color="primary"
                        onChange={(_, value) => setPage('cs', value)}
                      />
                    </Box>
                  ) : ("")}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: (storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED" ? 6 : 6), xl: ((storage.getItem('ClientGroupName') == "JBHIFI" || storage.getItem('ClientGroupName') == "MM" || storage.getItem('ClientGroupName') == "EXTENDED") ? 6 : 6) }}>
              <Box className='border h-100 border-main border-10 overflow-hidden'>
                <Box className='d-flex align-items-center justify-content-between mm-card-gradient mb-2 p-3'>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='p-1 border-10 bg-main d-flex align-items-center justify-content-center'>
                      <DonutLarge className='text-white' />
                    </Box>
                    <Typography className='text-dark fw-bold'>Score Distribution</Typography>
                    {/* <Typography className='text-dark' variant='caption'>(All reports YTD)</Typography> */}
                  </Box>
                  <Box className="selected   togglebutton3  d-flex align-items-center gap-3  justify-content-center mb-0">
                    <ToggleButtonGroup
                      className="d-flex justify-content-start m-0 p-0"
                      exclusive
                      value={isSDYTD}
                      onChange={(e: any) => setISSDYTD(e.target.value)}
                    >
                      <ToggleButton className="m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="false">
                        {dayjs(month).format('MMM-YY')}
                      </ToggleButton>
                      <ToggleButton sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} className="m-0" value="true">
                        YTD
                      </ToggleButton>

                    </ToggleButtonGroup>
                    <Link to={'/maindashboard/reports/groupmonthlysitescore'} className='text-main'>View Details</Link>
                  </Box>
                </Box>
                {clientData?.sd?.distribution?.length > 0 && (
                  <Box className='p-3'>
                    <DonutChart data2={clientData?.sd} />
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: (!domain.includes('aldi') && !domain.includes('blooms') && isratingJson ) ? 6 : 12 }}>
              <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
                <Box gap={2} className='d-flex align-items-center p-3   mm-card-gradient justify-content-between'>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='p-1 border-10 bg-main d-flex align-items-center justify-content-center'>
                      <WorkspacePremium className='text-white' />
                    </Box>
                    <Box>
                      <Typography className='text-dark fw-bold m-0 p-0' sx={{ lineHeight: 1 }}>Site Leaderboard</Typography>
                      <Typography variant='caption' className='text-dark m-0 p-0' sx={{ lineHeight: 1 }}>Click any venue to see drill-down</Typography>
                    </Box>
                  </Box>
                  <Box flex={1} className="selected w-100  togglebutton3  d-flex align-items-center gap-3  justify-content-end mb-0">
                    <ToggleButtonGroup
                      className="d-flex justify-content-start m-0 p-0"
                      exclusive
                      value={isSLYTD}
                      onChange={(e: any) => setIsSLYTD(e.target.value)}
                    >
                      <ToggleButton className="m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="false">
                        {dayjs(month).format('MMM-YY')}
                      </ToggleButton>
                      <ToggleButton sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} className="m-0" value="true">
                        YTD
                      </ToggleButton>

                    </ToggleButtonGroup>
                    <Link to={'/maindashboard/scoreCard'} className='text-main' style={{whiteSpace:'nowrap'}}>View Details</Link>
                  </Box>
                </Box>
                <Box flex={1} className='pt-0'>
                  {
                    // showLoading ? (
                    //   <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                    // ) :
                    (clientData?.vlb?.topVenues?.length > 0 || clientData?.vlb?.bottomVenues?.length > 0) ? (
                      <Box className='h-100'>
                        <Grid className='h-100' container alignItems={'stretch'} spacing={0}>
                          <Grid size={{ xs: 12, md: 'grow' }} >
                            <Box className='p-2 d-flex align-items-center justify-content-between' bgcolor={'var(--primary-light-main-color)'}>
                              <Typography variant='caption' className='fw-bold'>TOP {clientData?.vlb?.topVenues?.length}. {isSLYTD == 'true' ? `YTD-${month.format('YY')}` : `${month.format('MMM-YY')}`}</Typography>
                              <Typography variant='caption' className='fw-bold'>CX SCORE</Typography>
                            </Box>
                            {clientData?.vlb?.topVenues?.map((item: any) => (
                              <Box onClick={() => { getVenueLeaderBoardDetails(item?.venueId) }} sx={{ cursor: 'pointer', ":hover": { background: "#cccccc1A" } }} className='p-2 d-flex align-items-center justify-content-between border-bottom'>
                                <Box className='d-flex align-items-center gap-2'>
                                  <Box className='bg-primary-light-main' sx={{ borderRadius: '50%', lineHeight: 'normal', padding: "3px 11px" }}>
                                    <Typography variant='caption'>{item?.rank}</Typography>
                                  </Box>
                                  <Box>
                                    <Typography variant='body1' className='text-dark'>{item?.venueName}</Typography>
                                    <Box className='d-flex align-items-center gap-3'>
                                      <Box className='d-flex align-items-center'>
                                        <LocationPin sx={{ fontSize: '14px' }} />
                                        <Typography variant='caption' className='text-dark'> {item?.location}</Typography>
                                      </Box>
                                      {item?.starRating && (<Box className='d-flex align-items-center'>
                                        <Star sx={{ fontSize: '14px' }} />
                                        <Typography variant='caption' className='text-dark'> {item?.starRating}</Typography>
                                      </Box>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                                <Box className='d-flex align-items-center gap-2'>
                                  <Box>
                                    <Typography className='text-dark text-end' variant='body1'>{item?.score}%</Typography>
                                    <Box className='d-flex align-items-center gap-1'>
                                      {item?.trend == 'up' ? <ArrowOutward sx={{ fontSize: '14px' }} /> : <ArrowDownward sx={{ fontSize: '14px' }} />}
                                      <Typography variant='caption' className={item?.trend == 'up' ? 'text-main' : 'text-secondary'}>{item?.scoreDifference}%</Typography>
                                    </Box>
                                  </Box>
                                  <IconButton className='m-0 p-0'>
                                    <ArrowForwardIos className='fw-bold' sx={{ fontSize: '16px' }} />
                                  </IconButton>
                                </Box>
                              </Box>
                            ))}
                          </Grid>
                          <Grid
                            className="d-none d-md-flex"
                            size={{ xs: 12, md: 'auto' }}
                          >
                            <Box className='h-100' sx={{border:'1px solid #cccccc5A'}} />
                          </Grid>
                          <Grid size={{ xs: 12, md: 'grow' }}>
                            <Box className='p-2 d-flex align-items-center justify-content-between' bgcolor={'var(--third-light-color)'}>
                              <Typography variant='caption' className='text-secondary fw-bold'>BOTTOM {clientData?.vlb?.bottomVenues?.length}. {isSLYTD == 'true' ? `YTD-${month.format('YY')}` : `${month.format('MMM-YY')}`}</Typography>
                              <Typography variant='caption' className='text-secondary fw-bold '>CX SCORE</Typography>
                            </Box>
                            {clientData?.vlb?.bottomVenues?.map((item: any) => (
                              <Box className='p-2 d-flex align-items-center justify-content-between border-bottom' sx={{ cursor: 'pointer', ":hover": { background: "#cccccc1A" } }} onClick={() => { getVenueLeaderBoardDetails(item?.venueId) }}>
                                <Box className='d-flex align-items-center gap-2'>
                                  <Box bgcolor={'var(--third-light-color)'} sx={{ borderRadius: '50%', lineHeight: 'normal', padding: "3px 11px" }}>
                                    <Typography variant='caption' className='text-secondary'>{item?.rank}</Typography>
                                  </Box>
                                  <Box>
                                    <Typography variant='body1' className='text-dark'>{item?.venueName}</Typography>
                                    <Box className='d-flex align-items-center gap-3'>
                                      <Box className='d-flex align-items-center'>
                                        <LocationPin sx={{ fontSize: '14px' }} />
                                        <Typography variant='caption' className='text-dark'> {item?.location}</Typography>
                                      </Box>
                                      {item?.starRating && (<Box className='d-flex align-items-center'>
                                        <Star className='text-secondary' sx={{ fontSize: '14px' }} />
                                        <Typography variant='caption' className='text-dark'> {item?.starRating}</Typography>
                                      </Box>
                                      )}
                                    </Box>
                                  </Box>
                                </Box>
                                <Box className='d-flex align-items-center gap-2'>
                                  <Box>
                                    <Typography className='text-dark text-end' variant='body1'>{item?.score}%</Typography>
                                    <Box className='d-flex align-items-center gap-1'>
                                      {item?.trend == 'up' ? <ArrowOutward sx={{ fontSize: '14px' }} /> : <ArrowDownward className='text-secondary' sx={{ fontSize: '14px' }} />}
                                      <Typography variant='caption' className={item?.trend == 'up' ? 'text-main' : 'text-secondary'}>{item?.scoreDifference}%</Typography>
                                    </Box>
                                  </Box>
                                  <IconButton className='m-0 p-0'>
                                    <ArrowForwardIos className='fw-bold' sx={{ fontSize: '16px' }} />
                                  </IconButton>
                                </Box>
                              </Box>
                            ))}
                          </Grid>
                        </Grid>
                      </Box>
                    ) : (
                      <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                    )
                  }
                </Box>
              </Box>
            </Grid>
            {!domain.includes('aldi') && !domain.includes('blooms') && isratingJson && (
              <Grid size={{ xs: 12, md: 6, xl: 6 }}>
                <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
                  <Box p={1.6} className='d-flex align-items-center  mm-card-gradient justify-content-between'>
                    <Box className='d-flex align-items-center gap-2' sx={{ py: "7px" }}>
                      <Box className='p-1 border-10 bg-main d-flex align-items-center justify-content-center'>
                        <Star className='text-white' />
                      </Box>
                      <Typography className='text-dark fw-bold m-0 p-0'>Star Rating Average</Typography>
                    </Box>
                    <Box className="selected   togglebutton3  d-flex align-items-center gap-3  justify-content-center mb-0">
                      <ToggleButtonGroup
                        className="d-flex justify-content-start m-0 p-0"
                        exclusive
                        value={isSRYTD}
                        onChange={(e: any) => setIsSRYTD(e.target.value)}
                      >
                        <ToggleButton className="m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="false">
                          {dayjs(month).format('MMM-YY')}
                        </ToggleButton>
                        <ToggleButton sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} className="m-0" value="true">
                          YTD
                        </ToggleButton>

                      </ToggleButtonGroup>
                      <Link to={'/maindashboard/reports/reportstarrating'} className='text-main' style={{whiteSpace:'nowrap'}}>View Details</Link>
                    </Box>
                    {/* {JSON.parse(storage?.getItem('userOtherData') || "{}")?.venueCanSeeStarRating ? (<Link to={'/maindashboard/reports/reportstarrating'} className='text-main'>View Details</Link>) : (<></>)} */}
                  </Box>
                  <Box flex={1} className='p-3 pt-0'>
                    {showLoading ? (
                      <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                    ) :
                      sraPaginatedData?.length > 0 ? (
                        <Box>
                          <Grid container alignItems={'center'} sx={{
                            position: "relative",
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              left: 0,
                              right: 0,
                              bottom: 0,
                              height: "1px",
                              background: `repeating-linear-gradient(
                              to right,
                             #00000040 0px,
                             #00000040 12px,
                          transparent 12px,
                          transparent 20px
                          )`,
                            }, py: '12px',
                            marginBottom: '15px'
                          }} spacing={2}>
                            <Grid size={4}>
                              <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Category Name</Typography>
                            </Grid>
                            <Grid size={3}>
                              <Typography variant='caption' className='text-blue fw-bold m-0 p-0'>Ratings</Typography>
                            </Grid>
                            {/* <Grid size='grow' className='d-flex align-items-center gap-1'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'></Typography></Grid> */}
                            <Grid size='grow' className='d-flex align-items-center gap-1 justify-content-center'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>Your. Avg</Typography></Grid>
                            <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Typography variant='caption' className='text-dark text-blue fw-bold text-center m-0 p-0'>Ind. Avg</Typography></Grid>
                            <Grid size='grow' className='d-flex align-items-center justify-content-center'><Typography variant='caption' className='text-dark fw-bold text-blue text-center m-0 p-0'>vs Ind</Typography></Grid>
                          </Grid>
                          {
                            sraPaginatedData?.map((item: any) => (
                              <Box className='mb-3'>
                                <Grid container alignItems={'center'} spacing={2}>
                                  <Grid size={4}>
                                    <Typography variant='body2' className='text-dark m-0 p-0'>{item?.categoryName}</Typography>
                                  </Grid>
                                  <Grid size={3}>
                                    <Rating name="half-rating" sx={{ flex: 1, color: 'var(--primary-color)' }} className='m-0 p-0' defaultValue={item?.yourAverage} readOnly />
                                  </Grid>
                                  <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.yourAverage}</Typography></Grid>
                                  <Grid size='grow' className='d-flex align-items-center justify-content-center gap-1'><Box className='bg-third' height={'8px'} width={'8px'} borderRadius={'10px'}></Box><Typography variant='body2' className='text-dark text-center m-0 p-0'>{item?.industryAverage}</Typography></Grid>
                                  <Grid size='grow'><Typography variant='body2' className='text-dark text-center m-0 p-0 fw-bold' sx={{ color: `${getDifferenceStyle(item?.vsIndustry).color} !important` }}> {item?.vsIndustry > 0 ? "+" : ""}{item?.vsIndustry}</Typography></Grid>
                                </Grid>
                              </Box>
                            ))
                          }
                        </Box>
                      ) : (
                        <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                      )
                    }
                    {sraTotalPages > 1 ? (
                      <Box display="flex" justifyContent="center" mt={2}>
                        <Pagination
                          page={sraPage}
                          sx={{
                            "& .MuiPaginationItem-root.Mui-selected": {
                              backgroundColor: 'var(--primary-color)'
                            }
                          }}
                          count={sraTotalPages}
                          color="primary"
                          onChange={(_, value) => setPage('sra', value)}
                        />
                      </Box>
                    ) : ("")}
                  </Box>
                </Box>
              </Grid>
            )}
            <Grid size={{ xs: 12, md: 6, xl: 6 }}>
              <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
                <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between'>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='p-1 border-10 bg-main d-flex align-items-center justify-content-center'>
                      <CheckCircle className='text-white' />
                    </Box>
                    <Typography className='text-dark fw-bold m-0 p-0'>What's Working</Typography>
                  </Box>
                  <Box className="selected   togglebutton3  d-flex align-items-center gap-3 justify-content-center mb-0">
                    <ToggleButtonGroup
                      className="d-flex justify-content-start m-0 p-0"
                      exclusive
                      value={isYTD}
                      onChange={(e: any) => setIsYTD(e.target.value)}
                    >
                      <ToggleButton className="m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="false">
                        {dayjs(month).format('MMM-YY')}
                      </ToggleButton>
                      <ToggleButton sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} className="m-0" value="true">
                        YTD
                      </ToggleButton>

                    </ToggleButtonGroup>
                      <Link to={'/maindashboard/reports/questionsummaryreport'} className='text-main' style={{whiteSpace:'nowrap'}}>View Details</Link>
                  </Box>
                </Box>
                <Box flex={1} className='p-3 pt-0'>
                  {
                    // showLoading ? (
                    //   <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                    // ) :
                    qlbtPaginatedData?.length > 0 ? (
                      <Box>
                        {
                          qlbtPaginatedData?.map((item: any, index: number) => (
                            <Box className={`d-flex py-1 align-items-center justify-content-between gap-3 ${index == qlbtPaginatedData?.length - 1 ? " " : "border-bottom"}`}>
                              <Box>
                                <Typography variant='caption' className='text-dark fw-bold text-main'>{item?.categoryName}</Typography>
                                <Typography variant='body2' className='text-dark'>{item?.question}</Typography>
                              </Box>
                              <Typography variant='h6' className='tetx-main fw-bold'>{item?.percentage}%</Typography>
                            </Box>
                          ))
                        }
                      </Box>
                    ) : (
                      <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                    )
                  }
                  {qlbtTotalPages > 1 ? (
                    <Box display="flex" justifyContent="center" mt={2}>
                      <Pagination
                        page={qlbtPage}
                        sx={{
                          "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: 'var(--primary-color)'
                          }
                        }}
                        count={qlbtTotalPages}
                        color="primary"
                        onChange={(_, value) => setPage('qlbt', value)}
                      />
                    </Box>
                  ) : ("")}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, xl: 6 }}>
              <Box className='border d-flex flex-column border-main border-10 h-100 overflow-hidden'>
                <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between'>
                  <Box className='d-flex align-items-center gap-2'>
                    <Box className='p-1 border-10 bg-third d-flex align-items-center justify-content-center'>
                      <Warning className='text-white' />
                    </Box>
                    <Typography className='text-dark fw-bold m-0 p-0'>Needs Improvement</Typography>
                  </Box>
                  <Box className="selected   togglebutton3  d-flex align-items-center gap-3  justify-content-center mb-0">
                    <ToggleButtonGroup
                      className="d-flex justify-content-start m-0 p-0"
                      exclusive
                      value={isYTD}
                      onChange={(e: any) => setIsYTD(e.target.value)}
                    >
                      <ToggleButton className="m-0" sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} value="false">
                        {dayjs(month).format('MMM-YY')}
                      </ToggleButton>
                      <ToggleButton sx={{ py: 1, px: { xs: 3, md: 3 }, whiteSpace: 'nowrap' }} className="m-0" value="true">
                        YTD
                      </ToggleButton>

                    </ToggleButtonGroup>
                    <Link to={'/maindashboard/reports/questionsummaryreport'} className='text-main' style={{whiteSpace:'nowrap'}}>View Details</Link>
                  </Box>
                </Box>
                <Box flex={1} className='p-3 pt-0'>
                  {
                    // showLoading ? (
                    //   <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>Preparing your star rating and industry comparison…</Typography></Box>
                    // ) :
                    qlbbPaginatedData?.length > 0 ? (
                      <Box>
                        {
                          qlbbPaginatedData?.map((item: any, index: any) => (
                            <Box className={`d-flex py-1 align-items-center justify-content-between gap-3 ${index == qlbbPaginatedData?.length - 1 ? " " : "border-bottom"}`}>
                              <Box>
                                <Typography variant='caption' className='fw-bold text-brown'>{item?.categoryName}</Typography>
                                <Typography variant='body2' className='text-dark mt-1'>{item?.question}</Typography>
                              </Box>
                              <Typography variant='h6' className='tetx-main fw-bold' sx={{ color: '#BF613B' }}>{item?.percentage}%</Typography>
                            </Box>
                          ))
                        }
                      </Box>
                    ) : (
                      <Box className='h-100 d-flex align-items-center justify-content-center'><Typography>No Data Found</Typography></Box>
                    )
                  }
                  {qlbbTotalPages > 1 ? (
                    <Box display="flex" justifyContent="center" mt={2}>
                      <Pagination
                        page={qlbtPage}
                        sx={{
                          "& .MuiPaginationItem-root.Mui-selected": {
                            backgroundColor: 'var(--primary-color)'
                          }
                        }}
                        count={qlbtTotalPages}
                        color="primary"
                        onChange={(_, value) => setPage('qlbt', value)}
                      />
                    </Box>
                  ) : ("")}
                </Box>
              </Box>
            </Grid>
          </Grid>
        )
      }

      {/* ------------------------------------------------------------ Group Report -------------------------------------------- */}
      {(
        <>
          <Box className='d-flex align-items-center gap-2 mt-3 mb-3 flex-wrap'>
            <Box position='relative' maxWidth='100%' flex={1} className='border-10 border p-2 pb-3'>
              <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                <Box className="text-left d-flex align-items-center gap-2" width={{ xs: '15%' }}>
                  <Box className='p-1 border-10 bg-main d-flex align-items-center justify-content-center'>
                    <BarChart className='text-white' />
                  </Box>
                  <Typography fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >{domain.includes('aldi') ? 'Compliance' : storage.getItem('userRole') === 'venueadmin' ? `Group Report` : storage.getItem('userRole') === 'areaManager' ? "Your Area Report" : 'Your Group Report'} </Typography>
                </Box>
                <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={reportyear} className='month-select'
                      views={['year']}
                      format="YYYY"
                      onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                      maxDate={dayjs()}
                      slots={{
                        openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>
              {groupreport ? (<> <GroupReport diffbarcolor={false} totalheight={325} barWidth={40} horizontal={false} xAxis={monthNames} yAxis={scores} />
                {/* <Box

              sx={{
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translate(-50%, 0%)',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                px={5}
                sx={{ backgroundImage: `url(${chartlabel})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}
              >
                <Typography variant='caption' whiteSpace='nowrap'>
                  X-Axis: Months | Y-Axis: Ratings
                </Typography>
              </Box>
            </Box> */}
              </>)
                : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}
            </Box>

            {window.location.hostname.includes(Domains.ALDI) && storage.getItem('clientEntityName') !== 'Liquor ID' && (<Box position='relative' maxWidth='100%' flex={1} bgcolor={chart_bgcolor[1]} my={{ xs: 2, md: 0 }} className='border-10   p-2 pb-3'>
              <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                <Box className="text-left" width={{ xs: '15%' }}>
                  <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold">Moments that matter</Typography>
                </Box>
                <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={reportyear} className='month-select'
                      views={['year']}
                      format="YYYY"
                      onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                      maxDate={dayjs()}
                      slots={{
                        openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                      }}
                    />
                  </LocalizationProvider>
                </Box>
              </Box>

              {groupreport ? (<><GroupReport diffbarcolor={true} totalheight={325} barWidth={40} horizontal={false} xAxis={monthNames} yAxis={scores2} />
                {/* <Box

                  sx={{
                    position: 'absolute',
                    bottom: '0px',
                    left: '50%',
                    transform: 'translate(-50%, 0%)',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box
                    px={5}
                    sx={{ backgroundImage: `url(${chartlabel})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }}
                  >
                    <Typography variant='caption' whiteSpace='nowrap'>
                      X-Axis: Months | Y-Axis: Ratings
                    </Typography>
                  </Box>
                </Box>  */}
              </>
              ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}
            </Box>)}
          </Box>

          {window.location.hostname.includes(Domains.ALDI) && storage.getItem('clientEntityName') !== 'Liquor ID' && (
            <Box className='d-flex mt-2 align-items-stretch flex-wrap' gap={{ xs: 3, md: 2 }}>
              <Box position='relative' flex={1} maxWidth='100%' bgcolor={`${chart_bgcolor[2]}1A`} className='border-10  p-2 pb-3'>
                <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                  <Box className="text-left" width={{ xs: '15%' }}>
                    <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >Region Ranking Compliance</Typography>
                  </Box>
                  <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker value={reportyear} className='month-select'
                        views={['year']}
                        format="YYYY"
                        onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                        maxDate={dayjs()}
                        slots={{
                          openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
                {RegionRanking ? RegionRanking?.complianceScore?.map((item: any, index: number) =>
                (
                  <Box key={index} className='d-flex px-2 mt-3 align-items-center justify-content-between mb-3 gap-2'>
                    <Box width='5%'>
                      <Typography fontSize='14px' className='text-main'>{item?.regionName}</Typography>
                    </Box>
                    <Box className='d-flex gap-2' width={{ xs: '75%', md: '100%' }}>
                      <div className="custom-progress-bar">
                        <div className="progress-fill" style={{ width: `${item?.compliancefinalScore}%`, backgroundColor: `${chart_bgcolor[2]}` }}></div>
                      </div>
                      <Typography fontWeight={900} width='7%'>{item?.compliancefinalScore}%</Typography>
                    </Box>

                  </Box>
                )
                ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}

              </Box>

              <Box position='relative' flex={1} maxWidth='100%' bgcolor={`${chart_bgcolor[3]}1A`} className='border-10  p-2 pb-3'>
                <Box className="d-flex px-2 mb-0 justify-content-between align-items-center">
                  <Box className="text-left" width={{ xs: '15%' }}>
                    <Typography fontSize={{ md: '20px', xs: '14px' }} fontWeight='bold' whiteSpace={{ xs: 'nowrap' }} className="font-bold" >Region Ranking Moments that matter</Typography>
                  </Box>
                  <Box width={{ xs: '75%', md: 'auto' }} className="d-flex align-items-end  justify-content-end">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker value={reportyear} className='month-select'
                        views={['year']}
                        format="YYYY"
                        onChange={(e: any) => { setreportyear(e?.startOf('year')); }}
                        maxDate={dayjs()}
                        slots={{
                          openPickerIcon: ArrowDropDownIcon, // Replaces calendar icon
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
                {RegionRanking ? RegionRanking?.mystryShopeScore?.map((item: any, index: number) =>
                (
                  <Box key={index} className='d-flex px-2 mt-3 align-items-center justify-content-between mb-3 gap-2'>
                    <Box width='5%'>
                      <Typography fontSize='14px' className='text-main'>{item?.regionName}</Typography>
                    </Box>
                    <Box className='d-flex gap-2' width={{ xs: '75%', md: '100%' }}>
                      <div className="custom-progress-bar">
                        <div className="progress-fill" style={{ width: `${item?.mystryShopeScore}%`, backgroundColor: `${chart_bgcolor[3]}` }}></div>
                      </div>
                      <Typography fontWeight={900} width='7%'>{item?.mystryShopeScore}%</Typography>
                    </Box>

                  </Box>
                )
                ) : <Typography className='text-center my-5' variant='h5'>No Data Found</Typography>}

              </Box>

            </Box>
          )}
        </>
      )}
      <Drawer open={openVenueDetails}
        // onClose={() => {
        //   setClientData((prev: any) => ({
        //     ...prev,
        //     vlbd: [],
        //   }));
        //   setopenVenueDetails(false)
        // }}
        anchor='right' sx={{
          '& .MuiDrawer-paper': {
            width: '500px',
          },
        }}>
        <Box className={`p-3 px-4 ${clientData?.vlbd?.venueType === "BOTTOM" ? "bg-light-third" : "bg-primary-light-main"} border-bottom`}>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography variant='h5' className='fw-bold'>{clientData?.vlbd?.venueName}</Typography>
            <IconButton className='m-0 p-0' onClick={() => {
              setClientData((prev: any) => ({
                ...prev,
                vlbd: [],
              }));
              setopenVenueDetails(false)
            }}>
              <CancelOutlined />
            </IconButton>
          </Box>
          <Box className='d-flex align-items-center gap-3 mt-1'>
            <Box className='d-flex align-items-center gap-1 mt-1'>
              <LocationPin sx={{ fontSize: '16px' }} />
              <Typography variant='body2' className='text-dark'> {clientData?.vlbd?.location}</Typography>
            </Box>
            <Box className='d-flex align-items-center gap-1 mt-1'>
              <Typography variant='body2' className='text-dark'> {clientData?.vlbd?.visits}</Typography>
              <Typography variant='body2' className='text-dark'> Visits</Typography>
            </Box>
            <Typography variant='body2' className='text-dark'>{isSLYTD == 'true' ? `YTD-${month.format('YY')}` : `${month.format('MMM-YY')}`}</Typography>
          </Box>
          <Grid container mt={2} spacing={2}>
            <Grid size={{ xs: 12, md: 'grow' }} className='bg-light border-10 p-2 px-3' boxShadow={'0px 0px 3px #ccc'}>
              <Typography variant='caption' gutterBottom>CX SCORE</Typography>
              <Typography variant='h5' className={`${clientData?.vlbd?.venueType === "BOTTOM" ? "text-brown" : "text-main"} fw-bold`}>{clientData?.vlbd?.currentScore}%</Typography>
            </Grid>
            {clientData?.vlbd?.starAvg && (<Grid size={{ xs: 12, md: 'grow' }} className='bg-light border-10 p-2 px-3' boxShadow={'0px 0px 3px #ccc'}>
              <Typography variant='caption' gutterBottom>Star Avg</Typography>
              <Typography variant='h5' className='text-dark fw-bold'>{clientData?.vlbd?.starAvg}</Typography>
            </Grid>
            )}
            <Grid size={{ xs: 12, md: 'grow' }} className='bg-light border-10 p-2 px-3' boxShadow={'0px 0px 3px #ccc'}>
              <Typography variant='caption' gutterBottom>{isSLYTD == 'true' ? " Vs Last Year" : "Vs Last Time"}</Typography>
              <Typography variant='h5' className={`${clientData?.vlbd?.monthDelta >= 0 ? 'text-main' : 'text-secondary'} fw-bold`}>{clientData?.vlbd?.monthDelta}%</Typography>
            </Grid>
          </Grid>
        </Box>
        <Box className='p-3 px-4'>
          <Typography variant='caption' >CATEGORIES DRIVING THE SCORE</Typography>
          {clientData?.vlbd?.categoryScore?.length > 0 ? clientData?.vlbd?.categoryScore?.map((item: any) => (
            <Box className='my-3'>
              <Box className='d-flex mb-1 justify-content-between align-items-center'>
                <Typography>{item?.categoryName}</Typography>
                <Typography>{item?.score}%</Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={item?.score || 0}
                aria-label="Export data"
                sx={{
                  height: 10,
                  borderRadius: 5,
                  backgroundColor: clientData?.vlbd?.venueType === "BOTTOM" ? "var(--third-light-color)" :"var(--primary-light-main-color)",
                  "& .MuiLinearProgress-bar": {
                    background:clientData?.vlbd?.venueType === "BOTTOM" ? "var(--third-color)" :"var(--primary-color)",
                    borderRadius: 5,
                  },
                }}
              />
            </Box>
          )) : (
            <Typography className='text-center fw-bold'>No Data Found</Typography>
          )}
        </Box>
        <Box className='mt-3 px-4'>
          <Typography variant='caption' gutterBottom>{clientData?.vlbd?.venueType} QUESTIONS</Typography>
          {clientData?.vlbd?.questionScore?.length > 0 ? clientData?.vlbd?.questionScore?.map((item: any) => (
            <Box className='mb-2 d-flex py-1 align-items-center justify-content-between gap-2 border-bottom'>
              <Box>
                <Typography variant='caption' className={`fw-bold ${clientData?.vlbd?.venueType === "BOTTOM" ? "text-brown" : "text-main"}`}>{item?.categoryName}</Typography>
                <Typography variant='body2' className='text-dark mt-1'>{item?.question}</Typography>
              </Box>
              <Typography variant='h6' className='tetx-main fw-bold' sx={{ color: clientData?.vlbd?.venueType === "BOTTOM" ? '#BF613B' : "var(--primary-color)" }}>{item?.percentage}%</Typography>
            </Box>
          )) : (
            <Typography className='text-center fw-bold'>No Data Found</Typography>
          )}
        </Box>
        {/* {DrawerList} */}
      </Drawer>

      {/* <Footer/> */}
    </Box >
  )
}

export default Dashboard
